import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { getInjuryStatusClasses, getInjuryStatusLabel, type InjuryStatus } from '../../constants/injuries';

interface InjuryBadgeProps {
  injuryStatus: InjuryStatus;
  showLabel?: boolean;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export const InjuryBadge: React.FC<InjuryBadgeProps> = ({
  injuryStatus,
  showLabel = false,
  className = '',
  size = 'sm'
}) => {
  // Don't render anything if player is healthy (no injury badge needed)
  if (injuryStatus === 'H') return null;

  const sizeClasses = {
    xs: 'h-3 w-3 text-[10px] px-0.5 py-0',
    sm: 'h-4 w-4 text-xs px-1 py-0.5',
    md: 'h-5 w-5 text-sm px-1.5 py-1',
    lg: 'h-6 w-6 text-base px-2 py-1'
  };

  const iconSizeClasses = {
    xs: 'w-2 h-2',
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const injuryClasses = getInjuryStatusClasses(injuryStatus);
  const label = getInjuryStatusLabel(injuryStatus);

  if (showLabel) {
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full border font-medium ${sizeClasses[size]} ${injuryClasses} ${className}`}
        title={`Player is ${label}`}
      >
        <AlertTriangle className={iconSizeClasses[size]} />
        <span>{injuryStatus}</span>
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full border font-bold ${sizeClasses[size]} ${injuryClasses} ${className}`}
      title={`Player is ${label}`}
    >
      {injuryStatus}
    </span>
  );
}; 